/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #eee;
  }
`

export default function NoticeIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <g id="그룹_10835" data-name="그룹 10835" transform="translate(-4464 -6629)">
        <rect id="사각형_7370" data-name="사각형 7370" width="22" height="22" transform="translate(4464 6629)" fill="red" opacity="0"/>
        <path id="합치기_225" className="fill" data-name="합치기 225" d="M7.908,20.357a.751.751,0,0,1-.735-.6L5.718,12.627H3.562a.762.762,0,0,1-.1-.006C1.512,12.583,0,11.459,0,10.031V6.4C0,4.942,1.565,3.8,3.562,3.8H6.052a.766.766,0,0,1,.113-.043L18.774.031a.75.75,0,0,1,.963.719V15.907a.751.751,0,0,1-.966.718l-7.347-2.2.793,5.067a.749.749,0,0,1-.741.866Zm.612-1.5H10.6L9.758,13.48a.75.75,0,0,1,.957-.834L18.237,14.9V1.754L7.178,5.025v7.154h-.02ZM1.5,6.4v3.635c0,.516.883,1.091,2.063,1.091a.649.649,0,0,1,.095.006H5.178V5.3H3.562C2.382,5.3,1.5,5.88,1.5,6.4Z" transform="translate(4465.132 6629.822)" fill="#1c202b"/>
      </g>
    </svg>
  )
}
